const removeSpecialCharExceptComma = str => str.replace(/[^,a-zA-Z0-9]/g, '')

export default removeSpecialCharExceptComma
